(function () {
	let PARAM = "from"
	let KEY = "bv_referral"
	let MAX_AGE = 7776000
	let DATA_ID = "bv-referral-data"
	let PAGE_ATTR = "data-bv-referral-page"
	let FIXED_ATTR = "data-bv-referral-fixed"
	let OWNED_ATTR = "data-bv-referral-owned"
	let HANDLE_ATTR = "data-bv-referral-handle"
	let MARKER_PREFIX = "bv_ref:"
	let TAG_FIELD = {
		customer: "contact[tags]",
		create_customer: "customer[tags]"
	}

	let roster = null
	let referral = null

	function list() {
		if (roster) return roster
		roster = {}

		let node = document.getElementById(DATA_ID)
		if (!node) return roster

		try {
			for (let entry of JSON.parse(node.textContent)) {
				if (entry && entry.handle && entry.tag) roster[entry.handle] = entry
			}
		} catch (error) {
			roster = {}
		}

		return roster
	}

	function handleize(value) {
		return String(value)
			.trim()
			.toLowerCase()
			.normalize("NFD")
			.replace(/[^\x00-\x7f]/g, "")
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "")
	}

	function stored() {
		try {
			let raw = localStorage.getItem(KEY)
			if (raw) return JSON.parse(raw)
		} catch (error) {}

		let baked = document.cookie.match(/(?:^|;\s*)bv_referral=([^;]*)/)
		if (!baked) return null

		return list()[decodeURIComponent(baked[1])] || null
	}

	function remember(entry) {
		try {
			localStorage.setItem(KEY, JSON.stringify(entry))
		} catch (error) {}

		let secure = location.protocol === "https:" ? ";secure" : ""

		document.cookie =
			KEY + "=" + encodeURIComponent(entry.handle) + ";path=/;max-age=" + MAX_AGE + ";samesite=lax" + secure
	}

	function owner() {
		let node = document.querySelector("[" + PAGE_ATTR + "]")
		if (!node) return null

		return list()[handleize(node.getAttribute(PAGE_ATTR))] || null
	}

	function resolve() {
		let owned = owner()
		if (owned) {
			remember(owned)
			return owned
		}

		let asked = new URLSearchParams(location.search).get(PARAM)
		if (!asked) return stored()

		let entry = list()[handleize(asked)]
		if (!entry) return stored()

		remember(entry)
		return entry
	}

	function initials(name) {
		let words = name.split(/\s+/).filter(Boolean)
		if (!words.length) return ""

		let last = words.length > 1 ? words[words.length - 1] : ""

		return (words[0].charAt(0) + last.charAt(0)).toUpperCase()
	}

	function quote(root) {
		if (!referral.scripture) return

		let holder = root.querySelector("[data-bv-referral-quote]")
		if (!holder) return

		let text = holder.querySelector("[data-bv-referral-scripture]")
		if (text) text.textContent = referral.scripture

		let source = holder.querySelector("[data-bv-referral-scripture-source]")
		if (source) {
			source.textContent = referral.scriptureSource || ""
			source.hidden = !referral.scriptureSource
		}

		holder.hidden = false
	}

	function paint(root) {
		if (!referral) return

		quote(root)

		for (let slot of root.querySelectorAll("[data-bv-referral]")) {
			if (slot.hasAttribute(FIXED_ATTR)) continue

			for (let name of slot.querySelectorAll("[data-bv-referral-name]")) {
				name.textContent = referral.name
			}

			let photo = slot.querySelector("[data-bv-referral-photo]")
			let mark = slot.querySelector("[data-bv-referral-initials]")

			if (photo && referral.photo) {
				photo.src = referral.photo
				photo.alt = referral.name
				photo.hidden = false
				if (mark) mark.hidden = true
			} else if (mark) {
				mark.textContent = initials(referral.name)
				mark.hidden = false
			}

			slot.hidden = false
		}
	}

	function stamp(form) {
		if (!referral) return

		let handle = form.querySelector("[" + HANDLE_ATTR + "]")
		if (handle) handle.value = referral.handle
		if (form.querySelector("[" + OWNED_ATTR + "]")) return

		let type = form.querySelector("input[name=form_type]")
		if (!type) return

		let field = TAG_FIELD[type.value]
		if (!field) return

		let input = form.querySelector("input[name=" + CSS.escape(field) + "]")

		if (!input) {
			input = document.createElement("input")
			input.type = "hidden"
			input.name = field
			form.appendChild(input)
		}

		let marker = MARKER_PREFIX + referral.handle
		let tags = input.value.split(",").map(tag => tag.trim()).filter(Boolean)
		if (!tags.includes(marker)) tags.push(marker)

		input.value = tags.join(",")
	}

	function boot() {
		referral = resolve()
		paint(document)
	}

	document.addEventListener(
		"submit",
		event => {
			stamp(event.target)
		},
		true
	)

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot)
	} else {
		boot()
	}

	document.addEventListener("shopify:section:load", event => {
		paint(event.target)
	})
})()
